import Store from 'store/store';
import { getHeaderHeight } from 'utils/bolt/index';

export function getSectionScrollOffset(id) {
	const store = Store.get();

	const isDesktop = store?.client?.isDesktopSize;

	// for creative projects and whatnot
	const forceScrollOffsetDesktop = store?.appData?.options?.forceScrollOffsetForSection?.[id]?.desktop || store?.appData?.options?.forceScrollOffsetDesktop;
	if (isDesktop && forceScrollOffsetDesktop) return +forceScrollOffsetDesktop;
	const forceScrollOffsetMobile = store?.appData?.options?.forceScrollOffsetForSection?.[id]?.mobile || store?.appData?.options?.forceScrollOffsetMobile;
	if (forceScrollOffsetMobile) return +forceScrollOffsetMobile;

	if (store?.appData?.header?.uarHeader) return isDesktop ? 80 : 64;

	if (id === 'boltHome') return 0;
	return isDesktop ? getDesktopOffset(store, id) : getMobileOffset(store);
}

function getDesktopOffset(store, id) {
	if (store?.appData?.header?.powsterHeader?.solidBackground) {
		return getHeaderHeight();
	}

	const hasSonyHeader = store?.appData?.options?.sonyFeatures?.sonyHeader;
	const isHubPage = store?.appData?.pages?.[id]?.component === 'hub';

	if (hasSonyHeader || isHubPage) {
		return 34;
	}
	return 0;
}
function getMobileOffset(store) {
	const hasSonyHeader = store?.appData?.options?.sonyFeatures?.sonyHeader;

	if (hasSonyHeader) {
		return 58;
	}
	return getHeaderHeight();
}